import { Link } from 'react-router-dom';
import { StoreBadgeImages } from '@/components/shared/StoreBadges';
import { PUBLIC_ANCHORS, ROUTES } from '@/constants/routes';
import { BrandLogo } from './LandingNavbar';

export function LandingFooter() {
  return (
    <footer className="border-t border-gray-100 bg-brand-surface/60">
      <div className="container-page grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <BrandLogo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-brand-muted">
            Nigeria&apos;s trusted VTU platform for instant airtime, data, cable TV subscriptions, and bill payments.
          </p>
          <div className="mt-5">
            <p className="text-xs font-semibold uppercase tracking-wide text-brand-navy">Get our app</p>
            <StoreBadgeImages className="mt-3" size="sm" />
          </div>
        </div>

        <div>
          <h3 className="font-semibold text-brand-navy">Quick Links</h3>
          <ul className="mt-4 space-y-2 text-sm text-brand-muted">
            <li><a href={PUBLIC_ANCHORS.home} className="hover:text-primary">Home</a></li>
            <li><a href={PUBLIC_ANCHORS.services} className="hover:text-primary">Services</a></li>
            <li><a href={PUBLIC_ANCHORS.about} className="hover:text-primary">About Us</a></li>
            <li><a href={PUBLIC_ANCHORS.contact} className="hover:text-primary">Contact</a></li>
            <li><Link to={ROUTES.login} className="hover:text-primary">Login</Link></li>
            <li><Link to={ROUTES.register} className="hover:text-primary">Register</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-brand-navy">Services</h3>
          <ul className="mt-4 space-y-2 text-sm text-brand-muted">
            <li>Data Bundles</li>
            <li>Airtime Recharge</li>
            <li>Cable TV</li>
            <li>Electricity Bills</li>
            <li>Education Pins</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-brand-navy">Contact Us</h3>
          <ul className="mt-4 space-y-3 text-sm text-brand-muted">
            <li>info@asdatalink.com</li>
            <li>+234 806 666 4224</li>
            <li>Katsina, Nigeria</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-200/80">
        <div className="container-page flex flex-col items-center justify-between gap-3 py-6 text-sm text-brand-muted sm:flex-row">
          <p>© {new Date().getFullYear()} ASDATALINK. All rights reserved.</p>
          <p>
            Powered by{' '}
            <a
              href="https://www.furacomp.com/"
              target="_blank"
              rel="noreferrer"
              className="font-semibold text-primary hover:underline"
            >
              Furacomp Technologies
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
